import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

/**
 * PublicLayout - Wrapper for public-facing routes
 * Includes Header and Footer
 */
const PublicLayout = () => {
  const location = useLocation();

  return (
    <>
      <Header />
      <div key={location.pathname} className="page-transition">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default PublicLayout;
